import * as XLSX from 'xlsx';
import {
	FIELDS_MAPPER,
	IMPORT_COLUMNS,
	MAX_IMPORT_ROWS,
	type ImportField,
} from './parseImportExcel';

const SHEET_NAME = 'Foglio1';
const FILE_NAME = 'Template import veicoli.xlsx';

/**
 * Colonne che contengono codici: in una cella "Generale" Excel converte in
 * numero quanto viene digitato e perde gli zeri iniziali (il colore interno
 * "041" diventa 41, che poi non trova riscontro a listino). Pre-formattiamo
 * le celle come testo cosi' il codice resta quello scritto dall'operatore.
 * Le colonne data e PROMO restano "Generale": li' la conversione e' voluta.
 */
const TEXT_FIELDS: ImportField[] = [
	'codice_costruttore',
	'nr_ordine',
	'codice_colore_esterno',
	'codice_colore_interno',
	'optional_list',
	'telaio',
	'targa',
	'id_bo',
];

const textColumnIndexes = IMPORT_COLUMNS.reduce<number[]>(
	(acc, column, index) => {
		if (TEXT_FIELDS.includes(FIELDS_MAPPER[column])) acc.push(index);
		return acc;
	},
	[]
);

const headerWidth = (header: string): number =>
	Math.max(Math.ceil(header.length * 1.2) + 2, 12);

/**
 * Formatta come testo le colonne con codici dalla riga 1 a `lastRow`.
 */
export const applyTextColumnFormat = (
	sheet: XLSX.WorkSheet,
	lastRow: number
) => {
	for (let row = 1; row <= lastRow; row += 1) {
		for (const col of textColumnIndexes) {
			const address = XLSX.utils.encode_cell({ r: row, c: col });
			const value = sheet[address]?.v ?? '';
			sheet[address] = { t: 's', v: String(value), z: '@' };
		}
	}
};

export const columnWidths = (headers: string[]): XLSX.ColInfo[] =>
	headers.map((header) => ({ wch: headerWidth(header) }));

/**
 * Foglio con la sola riga di intestazione.
 */
export const buildImportTemplateSheet = (): XLSX.WorkSheet => {
	const sheet = XLSX.utils.aoa_to_sheet([
		IMPORT_COLUMNS as unknown as string[],
	]);

	applyTextColumnFormat(sheet, MAX_IMPORT_ROWS);

	sheet['!ref'] = XLSX.utils.encode_range({
		s: { r: 0, c: 0 },
		e: { r: MAX_IMPORT_ROWS, c: IMPORT_COLUMNS.length - 1 },
	});
	sheet['!cols'] = columnWidths(IMPORT_COLUMNS);

	return sheet;
};

export const downloadImportTemplate = () => {
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(
		workbook,
		buildImportTemplateSheet(),
		SHEET_NAME
	);
	XLSX.writeFile(workbook, FILE_NAME);
};
